export enum NotificationSource {
    TEST = 'TEST',
    MANUAL = 'MANUAL',
    FEED = 'FEED',
    PREVIEW = 'PREVIEW',
    CAMPAIGN = 'CAMPAIGN',
}
